var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerMenuOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4286 2.71428H1.35714C0.997205 2.71428 0.652011 2.5713 0.397498 2.31679C0.142984 2.06227 0 1.71708 0 1.35714C0 0.997205 0.142984 0.652011 0.397498 0.397498C0.652011 0.142984 0.997205 0 1.35714 0H24.4286C24.7885 0 25.1337 0.142984 25.3882 0.397498C25.6427 0.652011 25.7857 0.997205 25.7857 1.35714C25.7857 1.71708 25.6427 2.06227 25.3882 2.31679C25.1337 2.5713 24.7885 2.71428 24.4286 2.71428Z",
    fill: "#FAD762"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4286 10.8573H1.35714C0.997205 10.8573 0.652011 10.7144 0.397498 10.4599C0.142984 10.2053 0 9.86014 0 9.50021C0 9.14027 0.142984 8.79508 0.397498 8.54056C0.652011 8.28605 0.997205 8.14307 1.35714 8.14307H24.4286C24.7885 8.14307 25.1337 8.28605 25.3882 8.54056C25.6427 8.79508 25.7857 9.14027 25.7857 9.50021C25.7857 9.86014 25.6427 10.2053 25.3882 10.4599C25.1337 10.7144 24.7885 10.8573 24.4286 10.8573Z",
    fill: "#FAD762"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4286 18.9999H1.35714C0.997205 18.9999 0.652011 18.8569 0.397498 18.6024C0.142984 18.3479 0 18.0027 0 17.6428C0 17.2828 0.142984 16.9377 0.397498 16.6831C0.652011 16.4286 0.997205 16.2856 1.35714 16.2856H24.4286C24.7885 16.2856 25.1337 16.4286 25.3882 16.6831C25.6427 16.9377 25.7857 17.2828 25.7857 17.6428C25.7857 18.0027 25.6427 18.3479 25.3882 18.6024C25.1337 18.8569 24.7885 18.9999 24.4286 18.9999Z",
    fill: "#FAD762"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuOpenIcon);
export default __webpack_public_path__ + "static/media/burgerMenuOpen_icon.929aa0abe24adfbe1fb6168dee3dc9e1.svg";
export { ForwardRef as ReactComponent };